<template>
  <div>
    <common-list
      ref="list"
      url="VehicleManagement/GetListByVehicleType"
      :init="filter"
      :isindex="false"
      @currentrow="handlerCurrentRow"
      @selected="selected"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="收车时间">
            <DateRangePicker
              v-model="filter.SearchDate"
              placeholder="选择日期"
              clearable
            ></DateRangePicker>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option> </template>
      <!-- 数据展示区域 -->
      <template v-slot:body>
        <el-table-column
          type="selection"
          :selectable="disablechcekbox"
          width="55"
          :selectedValue="selectedValue"
        >
        </el-table-column>
        <el-table-column
          label="车辆类型"
          prop="VehicleTypeName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="收车数量"
          prop="VehicleNum"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }"> {{ row.VehicleNum }}</template>
        </el-table-column>
        <el-table-column label="铝圈数" prop="RingNum" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.RingNum | gang }}
          </template>
        </el-table-column>
        <el-table-column
          label="净重（kg）"
          prop="CarWeith"
          show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.CarWeith | gang }}
          </template>
          ></el-table-column
        >
        <el-table-column label="计算价" prop="CarPrice" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.CarPrice | gang }}
          </template>
          ></el-table-column
        >
      </template>
    </common-list>
    <!-- 弹窗区域 -->
    <div>
      <!-- <AddWeighDialog
        :item="itemAddWeighShow"
        @success="getData"
      ></AddWeighDialog>
      <ShowSettlementDialog
        :item="itemSettlementShow"
        @success="getData"
      ></ShowSettlementDialog> -->
    </div>
  </div>
</template>

<script>
// import "viewerjs/dist/viewer.css";
// import AddWeighDialog from "./Weigh";
// import ShowSettlementDialog from "./Settlement";
export default {
  components: {
    // AddWeighDialog,
    // ShowSettlementDialog,
  },
  computed: {},
  data() {
    return {
      Status: [],
      // itemAddWeighShow: {},
      // itemSettlementShow: {},
      filter: {
        StatusArray: [],
      },
      radio: 1,
      srcList: [],
      selectedValue: [],
      printoptions: {}, //打印参数
    };
  },
  watch: {},
  methods: {
    //重新加载数据
    getData() {
      this.$refs.list.getTableData();
    },

    disablechcekbox(row, index) {
      var boo = true;
      if (row.QueueStatus == 5) {
        boo = false;
      }
      return boo;
    },

    selected(val) {
      this.selectedValue = val;
    },
  },
};
</script>

<style></style>
